export default "/tower.glb";